<template>
  <div class="mw-100">
    <div class="flex items-center w-100" v-for="track in tracks" :key="track.id">
      <div class="flex justify-between items-center w-100 pr2">
        <button @click="setPlaylist(tracks); changeTrack(track)" class="pa2 textColor" title="Play">
          <font-awesome-icon icon="play"/>
        </button>
        <track-data :track="track" :class="{'info-container': !inArtistProfile, 'artist-profile-info-container': inArtistProfile}"/>
        <div class="playlistGenre">
          <p class="mv2 f7 textColor">{{track.genre.name}}</p>
        </div>
        <p class="mv2 f7 textColor">{{track.seconds | time}}</p>
        <div class="track-options relative">
          <track-options-button :track="track" :playlist="playlist" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TrackData from '@/components/tracks/TrackData.vue'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { mapActions } from 'vuex'
import TrackOptionsButton from './TrackOptionsButton.vue'
export default {
  name: 'simple-tracks-list',
  props: {
    tracks: {
      required: true
    },
    inArtistProfile: {
      default: false
    },
    playlist: {
      default: null
    }
  },
  components: {
    TrackData,
    FontAwesomeIcon,
    TrackOptionsButton
  },
  methods: {
    ...mapActions('player', [
      'setPlaylist',
      'changeTrack'
    ])
  }
}
</script>

<style scoped lang="scss">

button{
  border: none;
  background: none;
  margin: 0;
  cursor: pointer;
}

.track-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.title-width {
  max-width: 25vw;
}

.info-container {
  max-width: 50vw;
  min-width: 50vw;
  width: 50vw;
}

.artist-profile-info-container {
  max-width: 18vw;
  min-width: 18vw;
  width: 18vw;
}

.track-options {
  width: 5%;
  float: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.playlistGenre{
  width: 80px;
  text-align: center;
}

@media screen and (max-width: 780px) {
  .info-container {
    max-width: 40vw;
    min-width: 40vw;
    width: 40vw;
  }
  .artist-profile-info-container {
    max-width: 30vw;
    min-width: 30vw;
    width: 30vw;
  }
  .playlistGenre{
    width: 60px;
  }
}

@media screen and (max-width: 959px) {
  .title-width {
    max-width: 35vw;
  }
}

@media screen and (max-width: 479px) {
  .title-width {
    max-width: 70vw;
  }
  .artist-profile-info-container {
    max-width: 40vw;
    min-width: 40vw;
    width: 40vw;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tracks/SimpleTracksList.vue